export const isInstagramBrowser = (): boolean => {
  // For reference on what Instagram's in-app browser uses for user agent:
  // https://whatmyuseragent.com/apps/instagram-app. For some reason it doesn't
  // seem to include iOS but I just checked the user agent w/in my Instagram app
  // on iOS and it also had "Instagram" in it.
  return /instagram/i.test(navigator.userAgent);
};

export const isTikTokBrowser = (): boolean => {
  // For reference on what TikTok's in-app browser uses for user agent:
  // https://whatmyuseragent.com/apps/tiktok
  return /tiktok|bytedance|bytelocale/i.test(navigator.userAgent);
};

export const isAndroidUserAgent = (userAgent: string): boolean =>
  /Android/i.test(userAgent);

export const isAppleDevice = (userAgent: string): boolean =>
  /Macintosh|MacIntel|MacPPC|Mac68K|iPhone|iPad|iPod/i.test(userAgent);

/**
 * Whether signup surfaces should offer Apple Sign In.
 * Login keeps Apple available so existing Apple accounts can still authenticate
 * on Android (including Private Relay addresses).
 *
 * Defaults to true when navigator is unavailable so signup fails open to
 * showing Apple rather than hiding it by accident.
 */
export const supportsAppleSignIn = (
  userAgent: string = typeof navigator !== 'undefined'
    ? navigator.userAgent
    : ''
): boolean => !isAndroidUserAgent(userAgent);
